import type { AppCopy } from '../catalogs';

export const deAppCopy = {
  welcomeHeading: 'Wie kann ich Ihnen heute helfen?',
  thinking: 'Denken',
  scrollToBottom: 'Scrollen Sie nach unten',
  reasoning: 'Begründung',
  reasoningInProgress: 'in Bearbeitung',
  citationPages: 'Seiten {first}–{last}',
  citationTitle: 'Quellenauszug',
  citationLoading: 'Quelle wird geladen…',
  citationUnavailable: 'Der zitierte Text ist nicht verfügbar oder Sie haben keinen Zugriff mehr.',
  citationOpen: 'Quelle öffnen',
  citationCopied: 'Quellenangabe kopiert',
  copy: 'Kopieren',
  more: 'Mehr',
  tryAgain: 'Versuchen Sie es erneut',
  answerTruncated: 'Die Antwort hat das Längenlimit erreicht und wurde abgeschnitten.',
  continueAnswer: 'Antwort fortsetzen',
  exportMarkdown: 'Als Markdown exportieren',
  edit: 'Bearbeiten',
  cancel: 'Abbrechen',
  update: 'Aktualisieren',
  previous: 'Zurück',
  next: 'Als nächstes',
  messagePlaceholder: 'Senden Sie eine Nachricht…',
  projectHomePlaceholder: 'Neuer Chat in {project}',
  sharedChatEveryone: 'Alle bei {company} können diesen Chat lesen',
  sharedChatOnePerson: '1 Person kann diesen Chat lesen',
  sharedChatPeople: '{count} Personen können diesen Chat lesen',
  forkedChatPlaceholder: 'Mit Ihren eigenen Verbindungen fortfahren…',
  newAnswer: 'Neue Antwort',
  messageInput: 'Nachrichteneingabe',
  sendMessage: 'Nachricht senden',
  stopGenerating: 'Hören Sie auf zu generieren',
  addAttachment: 'Anhang hinzufügen',
  removeFile: 'Datei entfernen',
  attachmentPreview: 'Vorschau des Anhangs',
  imageAttachmentPreview: 'Vorschau des Bildanhangs',
  image: 'Bild',
  openLink: 'Link öffnen',
  document: 'Dokument',
  file: 'Datei',
  attachment: 'Anhang',
  uploadFailed: 'Hochladen fehlgeschlagen',
  uploading: 'Hochladen',
  toolIncomplete: 'Unvollständig',
  toolActivity: 'Aktivität',
  activityThinking: 'Denke…',
  activityWriting: 'Schreiben…',
  activityWaiting: 'Warten auf Ihre Genehmigung',
  activityStopped: 'Angehalten',
  activityCouldNotFinish: 'Konnte nicht abgeschlossen werden',
  activitySources: 'Quellen',
  activityShowThinking: 'Denken anzeigen',
  activityOpen: 'Aktivität öffnen',
  activitySteps: 'Schritte',
  activitySourcesTab: 'Quellen',
  activityUnavailable: 'Diese Aktivität ist nicht verfügbar.',
  activityInput: 'Eingabe',
  activityOutput: 'Ausgabe',
  activityNoSources: 'Diese Antwort enthält keine Quellenangaben.',
  activityApprovedByReply: 'Durch Ihre Antwort genehmigt',

  toolRunning: 'In Arbeit',
  toolComplete: 'Abgeschlossen',
  toolNeedsApproval: 'Genehmigung erforderlich',
  toolInput: 'Eingabe',
  toolCall: 'Werkzeugaufruf',
  toolCalls: 'Werkzeugaufrufe',
  openMenu: 'Menü öffnen',
  closeMenu: 'Menü schließen',
  close: 'Schließen',
  showInTextField: 'Im Textfeld anzeigen',
  settings: 'Einstellungen',
  appearance: 'Darstellung',
  themeLight: 'Hell',
  themeDark: 'Dunkel',
  themeSystem: 'System',
  themeChoiceHelp:
    'Gilt auf allen Ihren Geräten. „System“ folgt dem hellen oder dunklen Modus des jeweiligen Geräts.',
  themeSaveFailed:
    'Die Darstellung konnte nicht gespeichert werden und bleibt unverändert. Bitte versuchen Sie es erneut.',
  toolUsed: 'Verwendetes Tool',
  toolCancelled: 'Abgebrochenes Werkzeug',
  toolResult: 'Ergebnis:',
  toolError: 'Fehler:',
  toolCancelledReason: 'Grund für die Stornierung:',
  approvalAllow: 'Erlauben',
  approvalAlwaysAllow: 'Immer zulassen',
  approvalDeny: 'Ablehnen',
  approvalAlwaysDeny: 'Immer ablehnen',
  approvalConfirm: 'Bestätigen',
  approvalBack: 'Zurück',
  approvalApprovedResult: 'Vom Benutzer genehmigt',
  approvalDeniedResult: 'Der Benutzer hat die Ausführung des Tools verweigert',
  logout: 'Abmelden',
  loginOrCreateAccount: 'Anmelden / Konto erstellen',
  newChat: 'Neuer Chat',
  untitledChat: 'Chat ohne Titel',
  previousChats: 'Vorherige Chats',
  openChat: 'Chat öffnen {title}',
  moreActionsForChat: 'Weitere Aktionen für {title}',
  chatActions: 'Chat-Aktionen',
  closeChatActions: 'Chat-Aktionen schließen',
  deleteChatQuestion: 'Chat löschen?',
  deleteChatDescription: 'Der Chat „{title}“ wird dauerhaft gelöscht.',
  deleteChat: 'Chat löschen',
  keepChat: 'Chat behalten',
  delete: 'Löschen',
  deleting: 'Löschen…',
  chatDeleteFailed: 'Der Chat konnte nicht gelöscht werden. Versuchen Sie es erneut.',
  settingsDescription: 'Passen Sie an, wie der Assistent für Sie arbeitet.',
  settingsDesktopDescription: 'Passen Sie an, wie der Assistent auf Sie reagiert.',
  personalization: 'Personalisierung',
  personalizationDescription:
    'Passen Sie die Anweisungen an, denen der Assistent bei jeder Antwort folgt.',
  languageAndRegion: 'Sprache und Region',
  languageAndRegionDescription: 'Wähle Sprache und Zeitzone.',
  memories: 'Erinnerungen',
  memoriesDescription:
    'Sehen, bearbeiten oder löschen Sie, was der Assistent über Sie gespeichert hat.',
  account: 'Konto',
  accountDescription: 'Verwalten Sie das Konto und löschen Sie Ihre Daten dauerhaft.',
  backToSettings: 'Zurück zu den Einstellungen',
  closeSettings: 'Schließen Sie die Einstellungen',
  settingsCategories: 'Einstellungskategorien',
  yourSettings: 'Ihre Einstellungen',
  dataAndAccount: 'Daten und Konto',
  viewAndManageMemories: 'Sehen und verwalten Sie, woran sich der Assistent erinnert',
  loginToUseMemories: 'Melden Sie sich an, um Erinnerungen zu nutzen',
  manageOrDeleteAccount: 'Verwalten oder löschen Sie das Konto',
  unsavedChanges: 'Sie haben nicht gespeicherte Änderungen',
  unsavedCloseDescription:
    'Durch das Schließen der Einstellungen werden die Änderungen auf dieser Seite verworfen.',
  unsavedBackDescription: 'Wenn Sie zurückgehen, werden die Änderungen auf dieser Seite verworfen.',
  continueEditing: 'Bearbeiten Sie weiter',
  discardChanges: 'Änderungen verwerfen',
  saveChanges: 'Änderungen speichern',
  localSettingsNote:
    'In diesem Browser gespeichert. Melden Sie sich an, um in Ihrem Konto zu speichern.',
  personality: 'Persönlichkeit',
  personalityHelp: 'Benutzerdefinierte Anweisungen, denen der Assistent bei jeder Antwort folgt',
  personalityPlaceholder:
    'Zum Beispiel: Seien Sie prägnant und konkret. Ich lebe in Göteborg und mag vegetarisches Essen.',
  timezone: 'Zeitzone',
  searchTimezone: 'Zeitzonen durchsuchen…',
  automaticBrowser: 'Automatisch (Browser)',
  saved: 'Gespeichert {date}',
  addMemory: 'Erinnerung hinzufügen',
  newMemory: 'Neue Erinnerung',
  memoryPlaceholder: 'Zum Beispiel: Ich bevorzuge kurze, konkrete Antworten.',
  editMemory: 'Erinnerung bearbeiten',
  saveMemory: 'Erinnerung speichern',
  deleteMemory: 'Erinnerung löschen',
  memorySaveFailed: 'Der Speicher konnte nicht gespeichert werden. Versuchen Sie es erneut.',
  memoryLimitReached:
    'Sie können bis zu 50 Erinnerungen speichern. Löschen Sie eine, bevor Sie eine neue hinzufügen.',
  memoryInvalid:
    'Erinnerungen dürfen keine Links enthalten. Entfernen Sie den Link und versuchen Sie es erneut.',
  memoryDeleteFailed: 'Der Speicher konnte nicht gelöscht werden. Versuchen Sie es erneut.',
  memoryLoadFailed: 'Erinnerungen konnten nicht geladen werden.',
  loadingMemories: 'Erinnerungen werden geladen…',
  emptyMemories:
    'Der Assistent speichert Erinnerungen an Sie, während Sie sprechen – was Ihnen gefällt, wo Sie leben und was Sie tun. Sie können sie hier ansehen, bearbeiten und löschen.',
  deleteAccountHelp:
    'Löschen Sie das Konto und alle zugehörigen Chats, Erinnerungen und Einstellungen dauerhaft.',
  deleteAccount: 'Konto löschen',
  deleteAccountQuestion: 'Konto endgültig löschen?',
  deleteAccountDescription:
    'Alle Chats, Nachrichten, Erinnerungen, Einstellungen und Anmeldeinformationen werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  deleteAccountConfirm: 'Ja, lösche mein Konto',
  accountDeleteFailed:
    'Das Konto konnte nicht gelöscht werden. Es wurde nichts entfernt. Versuchen Sie es erneut.',
  logoutEverywhereTitle: 'Alle Geräte',
  logoutEverywhereHelp:
    'Melden Sie sich auf allen Geräten und in allen Browsern ab, in denen Ihr Konto geöffnet ist, auch auf diesem.',
  logoutEverywhere: 'Überall abmelden',
  logoutEverywhereQuestion: 'Auf allen Geräten abmelden?',
  logoutEverywhereDescription:
    'Sie müssen sich auf allen Geräten und in allen Browsern erneut anmelden, auch auf diesem. Ihre Chats und Einstellungen bleiben unverändert.',
  loggingOut: 'Abmeldung läuft…',
  logoutEverywhereFailed:
    'Wir konnten nicht bestätigen, dass Sie überall abgemeldet wurden. Versuchen Sie es erneut, oder prüfen Sie auf einem anderen Gerät, ob Sie noch angemeldet sind.',
  settingsSaveFailed: 'Einstellungen konnten nicht gespeichert werden. Versuchen Sie es erneut.',
  customInstructions: 'Benutzerdefinierte Anweisungen',
  notSet: 'Nicht festgelegt',
  automaticLanguage: 'Automatische Sprache',
  automaticTimezone: 'automatische Zeitzone',
  appLanguage: 'App-Sprache',
  appLanguageHelp:
    'Steuert die gesamte App-Oberfläche und Datumsangaben. Die Antworten des Assistenten folgen weiterhin der Sprache, in der Sie schreiben.',
  automaticBrowserLanguage: 'Automatisch (Browsersprache)',
  previousLanguageChoice: 'Vorherige Auswahl: {language} ({locale})',
  previousLanguageChoiceCode: 'Vorherige Auswahl ({locale})',
  canvasCopyLink: 'Link kopieren',
  canvasLinkCopied: 'Link kopiert',
  actionUpdatedWithEdits: 'Mit Ihren Änderungen aktualisiert',
  activityStepsDone: 'one:Schritt erledigt|other:Schritte erledigt',
  activityResultsCount: 'one:Ergebnis|other:Ergebnisse',
  canvasCopyLinkFailed: 'Link konnte nicht kopiert werden',
  canvasOpenInAgent: 'In {agent} öffnen',
  canvasExpand: 'Erweitern',
  canvasExitFullView: 'Vollansicht beenden',
  webSourceUnread:
    'In dieser Antwort verlinkt. Poneva hat diese Seite nicht gelesen, daher gibt es hier nichts anzuzeigen.',
  webSourceOpenOriginal: 'Original öffnen',
  toolProgressSettings: 'Ihre Einstellungen werden geändert…',
  toolProgressAgent: 'Der Agent wird erstellt…',
  toolProgressConnections: 'Verbindungsoptionen werden gesucht…',
  toolProgressResult: 'Ihr Ergebnis wird vorbereitet…',
  toolProgressClarification: 'Eine Rückfrage wird vorbereitet…',
  toolProgressKnowledge: 'Ein Vorschlag zur Wissensaktualisierung wird vorbereitet…',
  toolProgressQuestion: 'Eine Frage an Sie wird vorbereitet…',
  toolProgressSkill: 'Ihr Skill wird gestaltet…',
  toolErrorSettings: 'Ihre Einstellungen wurden nicht geändert.',
  toolErrorAgent: 'Der Agent konnte nicht erstellt werden.',
  toolErrorConnections: 'Verbindungsoptionen konnten nicht geladen werden.',
  toolErrorResult: 'Das Ergebnis wurde nicht gespeichert.',
  toolErrorClarification: 'Die Rückfrage konnte nicht vorbereitet werden.',
  toolErrorKnowledge: 'Der Vorschlag zur Wissensaktualisierung konnte nicht vorbereitet werden.',
  toolErrorQuestion: 'Die Frage konnte nicht vorbereitet werden.',
  toolErrorSkill: 'Der Skill-Entwurf konnte nicht gespeichert werden.',
  toolErrorOpenSettings: 'Einstellungen öffnen',
  toolErrorOpenAgents: 'Agenten öffnen',
  toolErrorOpenConnections: 'Verbindungen öffnen',
  toolStepIncomplete: 'Dieser Schritt wurde nicht abgeschlossen.',
  toolEarlierAttemptsFailed:
    'one:früherer Versuch ist nicht durchgegangen|other:frühere Versuche sind nicht durchgegangen',
} satisfies AppCopy;
